export default __webpack_public_path__ + "static/media/african-mask.ca902183.png";